import { useAppStore } from '../store/app'

export default (_to: any, _from: any, next: (arg0: string) => void) => {
  const appStore = useAppStore()
  appStore.signOutUser()
  next('/login')
}
